import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Hero from "../components/Hero";
import BrandMarquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Catalog from "../components/Catalog";
import PerfumeQuiz from "../components/PerfumeQuiz";
import { Offers, Launches } from "../components/OffersLaunches";
import GiftSets from "../components/GiftSets";
import Events from "../components/Events";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import CartDrawer from "../components/CartDrawer";
import WishlistDrawer from "../components/WishlistDrawer";
import ProductModal from "../components/ProductModal";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [events, setEvents] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/products"),
      api.get("/events"),
      api.get("/settings"),
      api.get("/testimonials"),
    ])
      .then(([p, e, s, t]) => {
        setProducts(p.data);
        setEvents(e.data);
        setSettings(s.data);
        setTestimonials(t.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const currency = settings?.currency || "RD$";

  const slides = [
    settings?.hero_image && {
      image: settings.hero_image,
      title: "Colección MO by Vir",
      subtitle: "Mini perfumes de autor",
    },
    ...products
      .filter((p) => p.featured || p.is_offer)
      .slice(0, 4)
      .map((p) => ({
        image: p.image,
        title: p.name,
        subtitle: p.is_offer ? "En oferta" : "Producto estrella",
      })),
  ].filter(Boolean);

  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex flex-col items-center justify-center gap-3">
        <div className="font-display text-5xl tracking-[0.2em] text-espresso animate-pulse">
          MO
        </div>
        <span className="font-serif italic text-rose">by Vir</span>
      </div>
    );
  }

  return (
    <div className="bg-cream overflow-x-hidden">
      <Header settings={settings} />
      <main>
        <Hero slides={slides} settings={settings} />
        <BrandMarquee logo={settings?.logo_image} />
        <Manifesto />
        <Catalog products={products} currency={currency} onOpen={setSelected} />
        <PerfumeQuiz products={products} currency={currency} onOpen={setSelected} />
        <Offers products={products} currency={currency} />
        <GiftSets products={products} currency={currency} onOpen={setSelected} />
        <Launches products={products} currency={currency} whatsapp={settings?.whatsapp_number} />
        <Events events={events} whatsapp={settings?.whatsapp_number} />
        <Testimonials testimonials={testimonials} />
        <Contact settings={settings} />
        <Newsletter />
      </main>
      <Footer settings={settings} />
      <WhatsAppFloat whatsapp={settings?.whatsapp_number} />
      <CartDrawer settings={settings} />
      <WishlistDrawer settings={settings} />
      <ProductModal
        product={selected}
        currency={currency}
        onClose={() => setSelected(null)}
      />
    </div>
  );
}
